import { render, staticRenderFns } from "./ParticipantsPanel.vue?vue&type=template&id=a5b25678&scoped=true&"
import script from "./ParticipantsPanel.vue?vue&type=script&lang=js&"
export * from "./ParticipantsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsPanel.vue?vue&type=style&index=0&id=a5b25678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b25678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
